import { Cos } from './cos'

class Honor {
    #COS;
    constructor(prefix = '/Honor/*', path = '/Honor/Attachment2222') {
        this.#COS = new Cos({
            prefix,
            path
        })
    }

    async putObject(file, options) {
        return await this.#COS.putObject(file, options)
    }
    
    getBasePrefix() {
        return this.#COS.basePrefix;
    }
    
    cancelTask(id) {
        return this.#COS.cancelTask(id)
    }
}
export default new Honor();